import apiClient from "../lib/apiClient";
import { error } from "../components/ui/toast";
import { useState, useEffect } from "react";

export function useWebSearch({ language, search }) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!search) {
            setData([]);
            return;
        }

        setLoading(true);

        apiClient
            .post("/getWebSearch", { language, search })
            .then((res) => setData(res.data || []))
            .catch((err) => {
                error(err?.response?.data?.error || "Something went wrong");
                setData([]);
            })
            .finally(() => setLoading(false));
    }, [language, search]);

    return { data, loading };
}
